import { CodeBase } from "./_codeBase";

/** 使用区分*/
export class UsageDiv extends CodeBase<UsageDiv>
{
    /** 使用区分: "01", "未使用"*/
    public static readonly NONE: UsageDiv = new UsageDiv("01", "未使用", "");
    /** 使用区分: "02", "共通"*/
    public static readonly COMMON: UsageDiv = new UsageDiv("02", "共通", "");
    /** 使用区分: "03", "担当"*/
    public static readonly SECTION: UsageDiv = new UsageDiv("03", "担当", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): UsageDiv[] {
        return [
            UsageDiv.NONE,
            UsageDiv.COMMON,
            UsageDiv.SECTION,
        ];
    }
}
